import MegaMenu from "./MegaMenu";

export default class Menu {
    constructor() {
        this.header = document.getElementById( 'site-header' );
        this.items = [];

        if ( !this.header ) {
            return;
        }
    }

    init() {
        if( !this.header ) {
            return; // Possible in the admin area.
        }

        this.items = this.header.getElementsByClassName( 'menu-item-has-children' );
        this.mouseEvents();
        this.initMegaMenu();
    }

    /**
     * Firing mouse Events.
     */
    mouseEvents() {
        if ( !this.items ) {
            return;
        }

        Array.from( this.items ).forEach( item => {
            item.addEventListener('mouseenter', () => this.openSubMenu( item ) );
            item.addEventListener('mouseleave', () => this.closeSubMenu( item ) );
        } );
    }

    /**
     * Update the sub-menu and child a11y attributes.
     * Enable when opened, disabled when closed.
     *
     * @param {HTMLObjectElement} item HTML element.
     * @param {boolean} status Status to set to.
     */
    updateSubMenu( item, status = false ) {
        if ( !item || window.matchMedia( '(max-width: 991px)' ).matches ) {
            return;
        }

        const toggle = item.querySelector( `[aria-expanded="${ !!status ? 'false' : 'true' }"]` );
        if ( toggle ) {
            toggle.setAttribute( 'aria-expanded', !!status );

            window.addEventListener('keydown', function listener(event) {
                if (event.key === 'Escape') {
                    toggle.setAttribute( 'aria-expanded', 'false' );
                }
                window.removeEventListener('keydown', listener);
            }, { once: true });
        }

        const tabIndex = !!status ? 0 : -1;

        const subMenu = item?.querySelector( '.sub-menu' );

        if( !! subMenu && !! subMenu?.children ) {
            // Using children since we do not want to get the children>children>children.
            Array.from( subMenu?.children ).forEach( els => {
                this.elementsWithAttributes( els.children ).forEach( el => el.tabIndex = tabIndex );
            } );
        }
    }

    /**
     * Filter array of HTML nodes based on specific attribute.
     *
     * @param {Array|HTMLCollection} elements Array of some sort. Will be cast to Array.
     * @param {string} attribute Attribute key to check.
     * @return {unknown[]}
     */
    elementsWithAttributes( elements, attribute = 'tabindex' ) {
        return Array.from( elements ).filter( el => el.hasAttribute( attribute ) );
    }

    /**
     * Open the sub-menu.
     *
     * @param {HTMLObjectElement} item HTML element.
     */
    openSubMenu( item ) {
        this.updateSubMenu( item, true );
    }

    /**
     * Close the sub-menu.
     *
     * @param {HTMLObjectElement} item HTML element.
     * @param {HTMLObjectElement} elementToSetFocus HTML element to set focus on when closing.
     */
    closeSubMenu( item, elementToSetFocus = null ) {
        this.updateSubMenu( item, false );

        if( !! elementToSetFocus ) {
            elementToSetFocus.focus();
        }
    }

    /**
     * Init the Mega Menu Class.
     */
    initMegaMenu() {
        const megaMenuItems = this.header.getElementsByClassName('has-mega-menu');
        if( !! megaMenuItems ) {
            new MegaMenu( megaMenuItems, this.items );
        }
    }
}
